export default __webpack_public_path__ + "static/media/DanskeNarrowSemibold.5d5ff94f.svg";